import { ErrorType } from "../datatypes/ErrorType"

export const LOG_IN_USER_ACTION_TYPE = 'LOG_IN_USER_ACTION_TYPE'
export const LOG_IN_USER_COMPLETED_ACTION_TYPE = 'LOG_IN_USER_COMPLETED_ACTION_TYPE'
export const LOG_IN_USER_LOCALLY_ACTION_TYPE = 'LOG_IN_USER_LOCALLY_ACTION_TYPE'
export const LOG_OUT_USER_COMPLETED_ACTION_TYPE = 'LOG_OUT_USER_COMPLETED_ACTION_TYPE'
export const LOG_OUT_USER_ACTION_TYPE = 'LOG_OUT_USER_ACTION_TYPE'

export interface ILogInType {
    accessToken: string | null,
    errorType: ErrorType | null,
    errorMessage: string | null,
}

export interface ILogInUserAction {
    type: string,
    body: string,
}

export interface ILogInUserLocalAction {
    type: string,
}

export interface ILogOutUserAction {
    type: string,
}

export interface ILogInUserCompletedAction {
    type: typeof LOG_IN_USER_COMPLETED_ACTION_TYPE;
    json: {
        access_token: string,
    },
    errorType: ErrorType,
    errorMessage: string,
}

export interface ILogOutUserCompletedAction {
    type: string,
}

// Creates a new action to log the user in (make server call).
export const createLogInUserAction = (body: string) : ILogInUserAction => {
    return {
        type: LOG_IN_USER_ACTION_TYPE,
        body: body,
    }
}

// Indicates that the current user has logged in.
export const createLogInUserCompletedAction = () => {
    return {
        type: LOG_IN_USER_COMPLETED_ACTION_TYPE,
    }
};

// Indicates that the current user has logged out.
export const createLogOutUserCompletedAction = () => {
    return {
        type: LOG_OUT_USER_COMPLETED_ACTION_TYPE,
    }
};

export const createLogInUserLocallyAction = () => {
    return {
        type: LOG_IN_USER_LOCALLY_ACTION_TYPE,
    }
};

export const createLogOutUserAction = () => {
    return {
        type: LOG_OUT_USER_ACTION_TYPE,
    }
};